
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password/email-notify",
      function () {
        return require("private-next-pages/forgot-password/email-notify.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot-password/email-notify"])
      });
    }
  